// Prevent multiple initializations
if (typeof productAddOnJSTest === 'undefined') {
  let productAddOnJSTest = false;
  const isUpsellDebugEnabled = () => globalThis.document?.body?.dataset?.upsellDebug === 'true';
  const upsellDebug = (eventName, payload = {}) => {
    if (!isUpsellDebugEnabled()) return;
    globalThis.console?.log(`[UpsellDebug] ${eventName}`, payload);
  };
  const upsellWarn = (eventName, payload = {}) => {
    if (!isUpsellDebugEnabled()) return;
    globalThis.console?.warn(`[UpsellDebug] ${eventName}`, payload);
  };

  // Main initialization function
  function productAddOnJS() {
    productAddOnJSTest = isUpsellDebugEnabled();
    upsellDebug('init:start');
    initializeAddonSliders();
    ProductAddonForm();
    initializeSwatchHandlers();
    initializeSelectHandlers();
    initializeSparkProductCardChecker();
  }

  function initializeAddonSliders() {
    const addonSlidersGrid = document.querySelectorAll(".add-on-products-grid");

    addonSlidersGrid.forEach((sliderGrid) => {
      const slider = sliderGrid.querySelector('.carousel-wrapper');
      const nextArrowSelector = sliderGrid.querySelector('.slider-nav.next');
      const prevArrowSelector = sliderGrid.querySelector('.slider-nav.prev');

      // Check if slider is already initialized and destroy it first
      if ($(slider).hasClass('slick-initialized')) {
        return;
      }

      $(slider).slick({
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: false,
        arrows: true,
        prevArrow: prevArrowSelector,
        nextArrow: nextArrowSelector
      });
    })
  }

  // Form handlers initialization
  function ProductAddonForm() {
    // Use event delegation for better performance
    const addonContainers = document.querySelectorAll('.add-on-accessories-block');

    addonContainers.forEach((addonContainer) => {
      if (!addonContainer) return;

      // Remove existing event listeners to prevent duplicates
      if (addonContainer._productAddonEventListeners) {
        addonContainer._productAddonEventListeners.forEach(({ type, listener }) => {
          addonContainer.removeEventListener(type, listener);
        });
      }

      // Store event listeners for cleanup
      addonContainer._productAddonEventListeners = [];

      // Cache DOM queries and create reusable functions
      const getFormElements = (form) => {
        const elements = {
          visibleQtyInput: form.querySelector('input.addons_qty'),
          hiddenQtyInput: form.querySelector('input[type="hidden"][name="quantity"]'),
          minusBtn: form.querySelector('.feather-minus')?.closest('.btn'),
          plusBtn: form.querySelector('.feather-plus')?.closest('.btn'),
          sizeSelect: form.querySelector('select[name^="options["]'),
          hiddenVariantIdInput: form.querySelector('input[type="hidden"][name="id"]'),
          addToCartBtn: form.querySelector('.addon-add-to-cart')
        };
        upsellDebug('form:elements', {
          productId: form.closest('.add-on-product-card')?.getAttribute('data-id'),
          hasSizeSelect: Boolean(elements.sizeSelect),
          hiddenIdValue: elements.hiddenVariantIdInput?.value || ''
        });
        return elements;
      };

      // Optimized quantity update function
      const updateQuantity = (form, change) => {
        const { visibleQtyInput, hiddenQtyInput } = getFormElements(form);
        if (!visibleQtyInput || !hiddenQtyInput) return;

        const currentVal = Math.max(1, (parseInt(visibleQtyInput.value, 10) || 1) + change);

        // Update both inputs simultaneously
        visibleQtyInput.value = currentVal;
        hiddenQtyInput.value = currentVal;

        // Debug logging (only if enabled)
        if (productAddOnJSTest) {
          const productCard = visibleQtyInput.closest('.add-on-product-card');
          console.log('Quantity updated:', {
            change,
            productId: productCard?.getAttribute('data-id'),
            newValue: currentVal
          });
        }
      };

      // Optimized add to cart function
      const addToCart = async (form) => {
        const { hiddenVariantIdInput, hiddenQtyInput } = getFormElements(form);

        const variantId = hiddenVariantIdInput?.value;
        const quantity = parseInt(hiddenQtyInput?.value, 10) || 1;
        const payload = { id: variantId, quantity };

        upsellDebug('addToCart:preflight', {
          productId: form.closest('.add-on-product-card')?.getAttribute('data-id'),
          variantId: variantId || '',
          quantity
        });

        if (!variantId) {
          upsellWarn('addToCart:missingVariantId', {
            productId: form.closest('.add-on-product-card')?.getAttribute('data-id'),
            payload
          });
          // Use a more user-friendly error message
          const errorMessage = document.createElement('div');
          errorMessage.className = 'addon-error-message';
          errorMessage.textContent = 'Please select a size before adding to cart.';
          errorMessage.style.cssText = 'color: #dc3545; font-size: 0.875rem; margin-top: 0.5rem;';

          // Remove any existing error messages
          form.querySelectorAll('.addon-error-message').forEach(msg => msg.remove());
          form.appendChild(errorMessage);

          // Auto-remove error message after 3 seconds
          setTimeout(() => errorMessage.remove(), 3000);
          return;
        }

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
            body: JSON.stringify(payload)
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          await response.json();
          upsellDebug('addToCart:success', {
            productId: form.closest('.add-on-product-card')?.getAttribute('data-id'),
            payload
          });

          // Dispatch cart change event
          document.documentElement.dispatchEvent(
            new CustomEvent('theme:cartchanged', {
              bubbles: true,
              cancelable: false,
              detail: { openDrawer: true }
            })
          );

          // Open cart drawer with a slight delay for better UX
          setTimeout(() => {
            document.dispatchEvent(new CustomEvent('theme:open-cart-drawer'));
          }, 1000);

        } catch (error) {
          upsellWarn('addToCart:error', {
            productId: form.closest('.add-on-product-card')?.getAttribute('data-id'),
            payload,
            message: error?.message || 'Unknown error'
          });
          console.error('Add to cart error:', error);

          // Show user-friendly error message
          const errorMessage = document.createElement('div');
          errorMessage.className = 'addon-error-message';
          errorMessage.textContent = 'Unable to add item to cart. Please try again.';
          errorMessage.style.cssText = 'color: #dc3545; font-size: 0.875rem; margin-top: 0.5rem;';

          form.querySelectorAll('.addon-error-message').forEach(msg => msg.remove());
          form.appendChild(errorMessage);

          setTimeout(() => errorMessage.remove(), 5000);
        }
      };

      // Event delegation for better performance
      const clickHandler = (event) => {
        const target = event.target;

        // Handle quantity buttons
        if (target.closest('.btn')) {
          const btn = target.closest('.btn');
          const form = btn.closest('.product-purchase-form');
          if (!form) return;

          const { minusBtn, plusBtn } = getFormElements(form);

          if (btn === minusBtn) {
            event.preventDefault();
            updateQuantity(form, -1);
          } else if (btn === plusBtn) {
            event.preventDefault();
            updateQuantity(form, 1);
          }
        }

        // Handle add to cart button
        if (target.closest('.addon-add-to-cart')) {
          event.preventDefault();
          const form = target.closest('.product-purchase-form');
          if (form) {
            addToCart(form);
          }
        }
      };

      // Add keyboard accessibility for quantity buttons
      const keydownHandler = (event) => {
        const target = event.target;

        if (target.closest('.btn')) {
          const btn = target.closest('.btn');
          const form = btn.closest('.product-purchase-form');
          if (!form) return;

          const { minusBtn, plusBtn } = getFormElements(form);

          if ((event.key === 'Enter' || event.key === ' ') && (btn === minusBtn || btn === plusBtn)) {
            event.preventDefault();
            updateQuantity(form, btn === minusBtn ? -1 : 1);
          }
        }
      };

      // Handle input changes and variant selection
      const inputHandler = (event) => {
        const target = event.target;
        const form = target.closest('.product-purchase-form');
        if (!form) return;

        const { visibleQtyInput, hiddenQtyInput, sizeSelect, hiddenVariantIdInput } = getFormElements(form);

        // Sync quantity inputs
        if (target === visibleQtyInput && hiddenQtyInput) {
          hiddenQtyInput.value = target.value;
        } else if (target === hiddenQtyInput && visibleQtyInput) {
          visibleQtyInput.value = target.value;
        }

        // Handle variant selection
        if (target === sizeSelect && hiddenVariantIdInput) {
          const hiddenIdBefore = hiddenVariantIdInput.value;
          const selectedOption = target.options[target.selectedIndex];
          if (selectedOption) {
            hiddenVariantIdInput.value = selectedOption.value;

            // Debug logging (only if enabled)
            if (productAddOnJSTest) {
              const productCard = target.closest('.add-on-product-card');
              console.log('Variant selected:', {
                productId: productCard?.getAttribute('data-id'),
                variantId: selectedOption.value,
                variantTitle: selectedOption.text
              });
            }
            upsellDebug('variant:selectChange', {
              productId: target.closest('.add-on-product-card')?.getAttribute('data-id'),
              selectedOption: selectedOption.text,
              hiddenIdBefore,
              selectValue: target.value,
              hiddenIdAfter: hiddenVariantIdInput.value
            });
          }
        }
      };

      // Add event listeners and store references for cleanup
      addonContainer.addEventListener('click', clickHandler);
      addonContainer.addEventListener('keydown', keydownHandler);
      addonContainer.addEventListener('input', inputHandler);

      // Store references for cleanup
      addonContainer._productAddonEventListeners = [
        { type: 'click', listener: clickHandler },
        { type: 'keydown', listener: keydownHandler },
        { type: 'input', listener: inputHandler }
      ];
    });
  }

  // Select handlers initialization
  function initializeSelectHandlers() {
    document.querySelectorAll('.add-on-product-card select.addons-select').forEach(select => {
      select.addEventListener('change', function () {
        const selectedOption = this.options[this.selectedIndex];
        const selectedValTitle = selectedOption ? selectedOption.text : '';

        const productBlock = this.closest('.product-block');
        if (!productBlock) return;

        const swatch = productBlock.querySelector(`.product-block-options__item[data-option-item="${selectedValTitle}"]`);
        if (swatch) {
          swatch.dispatchEvent(new Event('mouseenter', { bubbles: true }));
          swatch.click();
        }
      });
    });
  }

  // Swatch handlers initialization
  function initializeSwatchHandlers() {
    document.querySelectorAll('.add-on-product-card .product-block-options__item[data-option-item]').forEach(swatch => {
      // Trigger Change
      const triggerChange = () => {
        const optionValue = swatch.getAttribute('data-option-item');
        const swatchVariantId = swatch.getAttribute('data-variant-id');
        const productBlock = swatch.closest('.product-block');
        if (!productBlock) return;

        const select = productBlock.querySelector('select.addons-select');
        const addToCartBtn = productBlock.querySelector('.addon-add-to-cart');
        if (!select) return;

        const matchedOption = Array.from(select.options).find(opt => opt.text === optionValue);
        upsellDebug('swatch:triggerChange', {
          swatchProdId: swatch.getAttribute('data-prod-id'),
          swatchVariantId: swatchVariantId || '',
          optionValue,
          matchedOptionValue: matchedOption?.value || '',
          previousSelectValue: select.value
        });
        // Only trigger change if value is different
        if (matchedOption && select.value !== matchedOption.value) {
          select.value = matchedOption.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          addToCartBtn ? addToCartBtn.classList.remove('disabled') : null;
        }
      };

      //  Trigger Click
      const triggerClick = async () => {
        const swatchElem = swatch;

        if(swatchElem.closest('.single-product-options')) {
          // Single Product Options
          return; // exit the function
        }

        let addButton = swatchElem.closest('#product-addon-block').querySelector('.addon-add-to-cart');
        addButton ? addButton.classList.add('disabled') : null;

        let swatchId = swatchElem.getAttribute('data-prod-id');
        let swatchesContainer = swatch.closest('.product-block-options__inner');
        upsellDebug('swatch:triggerClick:start', {
          swatchProdId: swatchId,
          swatchVariantId: swatchElem.getAttribute('data-variant-id') || '',
          prodUrl: swatchElem.getAttribute('data-prod-url') || ''
        });

        swatchesContainer.querySelectorAll('.product-block-options__item').forEach(item => {
          item.classList.remove('swatch--active');
        });

        let prodUrl = swatchElem.getAttribute('data-prod-url');

        // ✅ Fetch without #fragment
        let fetchUrl = prodUrl;

        try {
          const response = await fetch(fetchUrl, {
            method: 'GET',
            headers: {
              'Accept': 'text/html'
            }
          });

          if (!response.ok) throw new Error(`HTTP error! ${response.status}`);

          const data = await response.text();
          const html = new DOMParser().parseFromString(data, 'text/html');

          const block = html.querySelector('#product-addon-block');
          if (block) {
            swatchElem.closest('#product-addon-block').innerHTML = block.innerHTML;
            const newHiddenVariantInput = document.querySelector('#product-addon-block input[type="hidden"][name="id"]');
            const newVariantSelect = document.querySelector('#product-addon-block select.addons-select');
            upsellDebug('swatch:triggerClick:afterReplace', {
              swatchProdId: swatchId,
              hiddenVariantId: newHiddenVariantInput?.value || '',
              selectValue: newVariantSelect?.value || ''
            });
          }

          setTimeout(() => {
            document.querySelector(`#product-addon-block .product-block-options__item[data-prod-id="${swatchId}"]`)?.classList.add('swatch--active');
            // Reinitialize only the necessary functions
            reinitializeAfterFetch();
            const delayedVariantInput = document.querySelector('#product-addon-block input[type="hidden"][name="id"]');
            const delayedSelect = document.querySelector('#product-addon-block select.addons-select');
            upsellDebug('swatch:triggerClick:postReinit', {
              swatchProdId: swatchId,
              hiddenVariantId: delayedVariantInput?.value || '',
              selectValue: delayedSelect?.value || ''
            });
          }, 1000);

        } catch (error) {
          console.error('Error fetching product:', error);
        }
      }

      swatch.addEventListener('click', triggerChange);
      swatch.addEventListener('click', triggerClick);
      swatch.addEventListener('mouseenter', triggerChange);
    });
  }

  // Function to check if spark-product-card has content and add class accordingly
  function initializeSparkProductCardChecker() {
    const checkSparkProductCards = () => {
      const sparkCards = document.querySelectorAll('.add-on-product-card spark-product-card');

      sparkCards.forEach(card => {
        const hasContent = checkSparkCardContent(card);

        if (hasContent) {
          card.classList.add('spark-card-has-content');
          card.classList.remove('spark-card-empty');
        } else {
          card.classList.add('spark-card-empty');
          card.classList.remove('spark-card-has-content');
        }
      });
    };

    // Initial check
    checkSparkProductCards();

    // Set up MutationObserver to watch for changes
    const observer = new MutationObserver((mutations) => {
      let shouldCheck = false;

      mutations.forEach(mutation => {
        // Check if any spark-product-card was added or modified
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.tagName === 'SPARK-PRODUCT-CARD' ||
                  node.querySelector && node.querySelector('spark-product-card')) {
                shouldCheck = true;
              }
            }
          });
        }

        // Check if any spark-product-card was modified
        if (mutation.type === 'attributes' &&
            mutation.target.tagName === 'SPARK-PRODUCT-CARD') {
          shouldCheck = true;
        }
      });

      if (shouldCheck) {
        // Debounce the check to avoid excessive calls
        clearTimeout(checkSparkProductCards.timeoutId);
        checkSparkProductCards.timeoutId = setTimeout(checkSparkProductCards, 100);
      }
    });

    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'data-*']
    });
  }

  // Helper function to check if spark-product-card has content
  function checkSparkCardContent(card) {
    // Check if the card itself has any text content
    if (card.textContent && card.textContent.trim()) {
      return true;
    }

    // Check if the card has any child elements
    if (card.children.length > 0) {
      return true;
    }

    // Check shadow DOM content if it exists
    if (card.shadowRoot) {
      const shadowContent = card.shadowRoot.textContent;
      if (shadowContent && shadowContent.trim()) {
        return true;
      }

      // Check for child elements in shadow DOM
      if (card.shadowRoot.children.length > 0) {
        return true;
      }
    }

    return false;
  }

  // Function to reinitialize after fetch (replaces reloadScript)
  function reinitializeAfterFetch() {
    // Reinitialize only the functions that need to work with the updated content
    initializeAddonSliders(); // Reinitialize sliders after content update
    ProductAddonForm();
    initializeSwatchHandlers();
    initializeSelectHandlers();
    initializeSparkProductCardChecker();

    // Initialize product block manager for newly loaded images
    const addonBlock = document.querySelector('.add-on-accessories-block');
    if (addonBlock && typeof window.theme !== 'undefined' && window.theme.ProductBlockManager) {
      window.theme.ProductBlockManager.loadImages(addonBlock);
    }
    upsellDebug('reinitializeAfterFetch:complete', {
      hasAddonBlock: Boolean(addonBlock),
      hiddenVariantId: document.querySelector('#product-addon-block input[type="hidden"][name="id"]')?.value || ''
    });
  }

  // Make reinitializeAfterFetch globally accessible for minicart quickbuy
  window.reinitializeAfterFetch = reinitializeAfterFetch;

  // Initial call
  productAddOnJS();
}